import { Injectable } from '@angular/core';

type LoadingContext = any;
type LoaderId = string | number;
const DEFAULT_LOADER_ID: LoaderId = '_DEFAULT';

@Injectable()
export class LoadingService {
    protected loadingStates = new WeakMap<LoadingContext, Map<LoaderId, boolean>>();

    isLoading(context: LoadingContext, loaderId?: LoaderId): boolean {
        const loaderStates = this.loadingStates.get(context);

        if (!loaderStates) {
            return false;
        } else {
            if (loaderId !== undefined) {
                return loaderStates.get(this.getLoaderId(loaderId)) ?? false;
            } else {
                return [...loaderStates.values()].filter((state) => state).length > 0;
            }
        }
    }

    startLoading(context: LoadingContext, loaderId?: LoaderId): void {
        this.setLoading(context, true, this.getLoaderId(loaderId));
    }

    endLoading(context: LoadingContext, loaderId?: LoaderId): void {
        this.setLoading(context, false, this.getLoaderId(loaderId));
    }

    clearLoadings(): void {
        this.loadingStates = new WeakMap<LoadingContext, Map<LoaderId, boolean>>();
    }

    protected setLoading(context: LoadingContext, state: boolean, loaderId: LoaderId): void {
        if (!this.loadingStates.has(context)) {
            this.loadingStates.set(context, new Map<LoaderId, boolean>([[loaderId, state]]));
        } else {
            this.loadingStates.get(context).set(loaderId, state);
        }
    }

    protected getLoaderId(loaderId?: LoaderId): LoaderId {
        return loaderId ?? DEFAULT_LOADER_ID;
    }
}
